import * as z from 'zod';

/**
 * Per-vendor delivery state — `vendor_broadcast_recipients.status` on the
 * wire. `fresh` is unseen, `viewed` is seen but unanswered, `expired` is past
 * `expires_at` without a response.
 */
export const vendorBroadcastStatusSchema = z.enum([
  'fresh',
  'viewed',
  'accepted',
  'rejected',
  'expired',
]);
export type VendorBroadcastStatus = z.infer<typeof vendorBroadcastStatusSchema>;

/**
 * One broadcast as the vendor sees it — title/message already resolved to the
 * request's `Accept-Language` (`VendorBroadcastForVendor` on the wire).
 */
export const vendorBroadcastSchema = z.object({
  id: z.number(),
  broadcast_id: z.number(),
  title: z.string(),
  message: z.string(),
  file_path: z.string().nullable(),
  file_name: z.string().nullable(),
  with_action: z.boolean(),
  expires_at: z.string().nullable(),
  status: vendorBroadcastStatusSchema,
  reject_reason: z.string().nullable(),
  responded_at: z.string().nullable(),
  created_at: z.string(),
  total_count: z.number(),
});
export type VendorBroadcast = z.infer<typeof vendorBroadcastSchema>;

export const vendorBroadcastListSchema = z.array(vendorBroadcastSchema);
export type VendorBroadcastList = z.infer<typeof vendorBroadcastListSchema>;

export const unreadBroadcastCountSchema = z.object({ count: z.number() });
